<template>
  <div>
    <h1 class="settings-title">
      Subscribers
    </h1>
    <div
      class="settings-form">
      <h2 class="settings-subtitle">
        Unsubscribe
      </h2>
      <b-form-group>
        <label class="settings-label">
          <span>Unsubscribe Keyword</span>
          <icon
            id="stop-word-description"
            v-b-tooltip="getTooltipConfig('Keyword that contact can send to unsubscribe from receiving notifications.')"
            name="info-circle"
            class="info-label"/>
        </label>
        <b-input
          value="stop"
          class="mb-2"
          disabled/>
      </b-form-group>
      <b-form-group>
        <label class="settings-label">
          <span>Unsubscribe Confirmation Message</span>
          <icon
            id="unsubscribe-message-description"
            v-b-tooltip="getTooltipConfig('Message that will be sent to contact after they unsubscribe.')"
            name="info-circle"
            class="info-label"/>
        </label>
        <MessageTextArea
          ref="messageArea"
          :enter-submit="false"
          :no-tags="true"
          :native-tags="true"
          placeholder="Unsubscribe message..."/>
        <span
          v-if="validationErrors.unsubscribeMessage"
          class="validation-error">{{ validationErrors.unsubscribeMessage }}</span>
      </b-form-group>
      <div class="clearfix"/>
      <div
        v-if="subscriberSettingsSaved"
        class="success-info">
        Subscriber settings have been successfully updated.
      </div>
      <div
        v-if="errorMessage"
        class="error-message">
        {{ errorMessage }}
      </div>
      <b-button
        :class="{loading: saving}"
        :disabled="saving"
        class="btn-round btn-save"
        @click="updateNotificationSettings">
        <span v-if="!saving">Save</span>
        <div class="loader"><div class="loading-circle"/></div>
      </b-button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import setValidationErrors from '@/helpers/validationErrors';
import MessageTextArea from '../../common/MessageTextArea';

export default {
  name: 'SubscriberSettings',
  components: {
    MessageTextArea,
  },
  data() {
    return {
      saving: false,
      subscriberSettingsSaved: false,
      errorMessage: '',
      validationErrors: {},
    };
  },
  computed: {
    ...mapGetters({
      automationSettings: 'automation/automationSettings',
      unsubscribeMessageSaved: 'automation/unsubscribeMessageSaved',
      apiError: 'automation/apiError',
    }),
  },
  watch: {
    unsubscribeMessageSaved(saved) {
      if (saved) {
        this.saving = false;
        this.subscriberSettingsSaved = true;
        setTimeout(() => {
          this.subscriberSettingsSaved = false;
        }, 3000);
      }
    },
    automationSettings(settings) {
      if (settings) {
        this.$refs.messageArea.setText(settings.unsubscribe_message);
      }
    },
    apiError(error) {
      this.saving = false;
      if (error.status === 422) {
        this.validationErrors = setValidationErrors(error.data.errors);
      } else {
        this.errorMessage = error.message;
      }
    },
  },
  mounted() {
    this.fetchSettings(this.$route.params.merchant_id);
  },
  methods: {
    ...mapActions({
      fetchSettings: 'automation/fetchSettings',
      updateUnsubscribeMessage: 'automation/updateUnsubscribeMessage',
    }),
    getTooltipConfig(text) {
      return {
        title: text,
        placement: 'right',
        animation: false,
        offset: '0, 5px',
      };
    },
    updateNotificationSettings() {
      this.validationErrors.unsubscribeMessage = '';

      this.saving = true;
      const payload = {
        merchant_id: this.$route.params.merchant_id,
        data: {
          unsubscribe_message: this.$refs.messageArea.getText(),
        },
      };

      this.updateUnsubscribeMessage(payload);
    },
  },
};
</script>
